import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import ReactHtmlParser from 'react-html-parser';

import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TableContainer from '@material-ui/core/TableContainer';
import Typography from '@material-ui/core/Typography';
import styles from "assets/jss/material-kit-react/components/learningDetailsStyle.js";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
import BeatLoader from "react-spinners/BeatLoader";
import {Helmet} from 'react-helmet'

const useStyles = makeStyles(styles);

export default function History(props) {
  const classes = useStyles();
  let [loading, setLoading] = useState(true);
  let [product, setProduct] = useState(true);


  useEffect(() => {
    Axios.post(Config.api + "Product/GetProducts", {
      productShortId: props.id
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: (localStorage.getItem('token')) ? "Bearer " + localStorage.getItem('token') : ""
        }
      }).then((result) => {
        setLoading(false)
        setProduct(result.data.data[0])
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }, [])

  return (
    <form noValidate autoComplete="off">
       <Helmet>
    <title>{"جزییات دوره "+product?.title+" | کمپ آموزشی شریف"}</title>
    <meta name="description" content={product?.title+" توسط استاد مجرب تدریس شده و در پایان دوره مدرک معتبر دانشگاه صنعتی شریف ارائه میگردد."} />
    <meta name="keywords" content={["Product","Classes","sharifcamp","Programming","C++","C#","NODEJS","HCNA","CCNA","Linux",product && product.tags]} />
  </Helmet>
      
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/uikit@3.7.2/dist/css/uikit.min.css" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/uikit@3.7.2/dist/css/uikit.rtl.min.css" />
      <script src="https://cdn.jsdelivr.net/npm/uikit@3.7.2/dist/js/uikit.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/uikit@3.7.2/dist/js/uikit-icons.min.js"></script>
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.div + " " + classes.fastAccess} >
                <Typography variant="h6" gutterBottom>
                  {product && product.title}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {ReactHtmlParser(product ? product.description : "")}
                </Typography>
                <TableContainer className={classes.tableContainer} >
                  <div className={classes.center + " " + classes.fastAccess}>
                    <BeatLoader loading={loading} color={"gray"} size={15} />
                  </div>
                </TableContainer>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </form>
  );
}